import { Outlet } from 'react-router-dom';
import { colors } from '@yorukiri/ui/tokens';
import { Sidebar } from './components/Sidebar';

export function App() {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '232px 1fr',
        height: '100vh',
        background: colors.bg,
      }}
    >
      <Sidebar />
      <main style={{ overflow: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
